const menuAboutDE = {
    "view": {
        "label": {
            "myProfile": "Mein Profil",
            "twoFactorAuthentication": "Zwei-Faktor-Authentifizierung",
            "mySubscription": "Mein Abonnement",
            "announcements": "Ankündigungen",
            "mySubUsers": "Meine Unterbenutzer",
            "myLabels": "Meine Labels",
            "escrowWallet": "Treuhand-Wallet",
            "copyright": "Urheberrechtsverletzungen",
            "financialStatements": "Finanzberichte",
            "userStatements": "Benutzerberichte",
            "subuserStatements": "Unterbenutzerberichte",
            "invoices": "Rechnungen",
            "paymentMethods": "Zahlungsmethoden",
            "purchaseHistory": "Kaufhistorie",
            "accessKeys": "Zugriffsschlüssel",
            "logout": "Abmelden"
        }
    }
};

export default menuAboutDE;